<nz-card class="flow-card" nzTitle="Customer Profile">
  <!-- <p class="flow-card__subtitle">Confirm the lead's info so we can prefill the rest of the Dish flow with confidence.</p> -->

  <form nz-form [formGroup]="infoForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="firstName">First Name</nz-form-label>
      <nz-form-control>
        <input nz-input id="firstName" formControlName="firstName" maxlength="25" placeholder="Customer first name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="lastName">Last Name</nz-form-label>
      <nz-form-control>
        <input nz-input id="lastName" formControlName="lastName" maxlength="50" placeholder="Customer last name" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="phone">Phone</nz-form-label>
      <nz-form-control [nzValidateStatus]="infoForm.get('phone')">
        <input nz-input id="phone" type="tel" maxlength="10" minlength="10" formControlName="phone"
          placeholder="10-digit phone" />
        <nz-form-explain *ngIf="infoForm.get('phone')?.touched && infoForm.get('phone')?.errors?.['selfPhone']">
          Can't be your own number
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="email">Email</nz-form-label>
      <nz-form-control [nzValidateStatus]="infoForm.get('email')">
        <input nz-input id="email" formControlName="email" placeholder="Email" />
        <nz-form-explain *ngIf="infoForm.get('email')?.touched && infoForm.get('email')?.errors?.['email']">
          Please enter a valid email address
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="dob">Date of Birth</nz-form-label>
      <nz-form-control [nzValidateStatus]="infoForm.get('dob')">
        <input nz-input id="dob" type="date" formControlName="dob" placeholder="YYYY-MM-DD" />
        <nz-form-explain *ngIf="infoForm.get('dob')?.touched && infoForm.get('dob')?.errors?.['notAdult']">
          Must be 18+
        </nz-form-explain>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="address">Address</nz-form-label>
      <nz-form-control>
        <input nz-input id="address" formControlName="address" placeholder="Street address" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item class="flow-form__item">
      <nz-form-label [nzRequired]="true" nzFor="city">City</nz-form-label>
      <nz-form-control>
        <input nz-input id="city" formControlName="city" placeholder="City" />
      </nz-form-control>
    </nz-form-item>

    <nz-row [nzGutter]="16" class="form-row">
      <nz-col [nzSpan]="12" class="form-row__col">
        <nz-form-item class="flow-form__item">
          <nz-form-label [nzRequired]="true" nzFor="state">State</nz-form-label>
          <nz-form-control>
            <nz-select id="state" formControlName="state" placeholder="State">
              <nz-option *ngFor="let s of states" [nzValue]="s.value" [nzLabel]="s.value + ' — ' + s.label"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </nz-col>

      <nz-col [nzSpan]="12" class="form-row__col">
        <nz-form-item class="flow-form__item">
          <nz-form-label [nzRequired]="true" nzFor="zip">Zip</nz-form-label>
          <nz-form-control>
            <input nz-input id="zip" type="tel" maxlength="5" formControlName="zip" placeholder="Zip" />
          </nz-form-control>
        </nz-form-item>
      </nz-col>
    </nz-row>

    <nz-form-item class="flow-form__item">
      <nz-form-control>
        <label nz-checkbox formControlName="permissionToCall">Permission to call?</label>
      </nz-form-control>
    </nz-form-item>

    <div class="flow-actions flow-actions--trailing">
      <button nz-button nzType="primary" nzBlock
        [disabled]="infoForm.invalid || !infoForm.get('dob')?.value || infoForm.get('dob')?.value === 'null'"
        (click)="submitForm()" [nzLoading]="btnLoading">
        Create Lead
      </button>
    </div>
  </form>
</nz-card>